import React from 'react';
import { ArrowRight, MessageSquare, BarChart3, Brain } from 'lucide-react';
import { images } from '../mock';

const Hero = ({ t, onCtaClick, onSecondaryClick }) => {
  return (
    <section className="hero-section">
      <div className="hero-grid">
        <div className="hero-content">
          <h1 className="hero-title heading-hero" data-testid="hero-title">
            {t.hero.title}
          </h1>
          
          <p className="hero-subtitle body-large" data-testid="hero-subtitle">
            {t.hero.subtitle}
          </p>
          
          <div className="hero-actions">
            <button onClick={onCtaClick} className="btn-primary" data-testid="hero-cta-btn">
              {t.hero.cta}
              <ArrowRight size={16} />
            </button>
            <button onClick={onSecondaryClick} className="btn-secondary" data-testid="hero-secondary-btn">
              {t.hero.secondary}
            </button>
          </div>

          <div className="hero-badges">
            <div className="hero-badge">
              <MessageSquare size={16} />
              <span>AI Assistant</span>
            </div>
            <div className="hero-badge">
              <BarChart3 size={16} />
              <span>Smart Analytics</span>
            </div>
            <div className="hero-badge">
              <Brain size={16} />
              <span>Agentic AI</span>
            </div>
          </div>
        </div>
        
        <div className="hero-visual" data-testid="hero-visual">
          <div className="hero-image-container">
            <img 
              src={images.hero}
              alt="Emma AI Assistant" 
              className="hero-image"
            />
            <div className="hero-glow" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
